import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchQuestion(params) {
  return await request({
    url: ENDPOINT.HOME_QUESTION,
    method: "get",
    params,
  });
}